export default __webpack_public_path__ + "static/logo_vertical_positive_mono_lockup-a5dc9d4afb03728cbf387ebfbcaa8b8d.svg";